import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, FormGroup, Label, Input, Card, CardBody, Row, Col, CardHeader, Table } from "reactstrap";
import { getZoneListByPlace, getSubZoneListByZone, getVehicalCategoryList, getVehicalTypeList, getVehicalNumberList, getTicketType, getTicketSubType, getTicketSubSubType, getAllZonesByPlace, getAllCategoriesAndVehicals, getBookingTimingFormData } from "../../redux/actions/indexActions";
import axios from "axios";
import { toast } from "react-toastify";
import AdditionalFormFields from "./AdditionalFormFields";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { Link } from "react-router-dom";

const PlaceZone = ({ placeId }) => {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state.AuthReducer);
    const { indexReducer: { PlaceZonelists = [], VehicalCategoryList, VehicalsTypelists, VehicalsNumberlists ,TicketTypeList, TicketSubTypeList ,TicketSubSubTypeList,vehicleTypeList,vehicleCategoriesList,vehicleNumList,bookingTimings} } = useSelector((state) => state);
    const [placeZoneId, setPlaceZoneId] = useState(0);
    const [VehicalCategory, setVehicalCategory] = useState(0);
    const [VehicalTypeId, setVehicalTypeId] = useState(0);
    const [isEdit, setIsEdit] = useState({
        category:false,
        type:false,
        number:false,
    });
    const [isEnabledZone, setIsEnabledZone] = useState(false);
    const [isEnabledCategory, setIsEnabledCategory] = useState(false);
    const [isEnabledSubCategory, setIsEnabledSubCategory] = useState(false);
    const [isCapacity, setCapacity] = useState(false);
    const [vehicleCategories, setVehicleCategories] = useState([{id:'',category:''}]);
    const [vehicleTypes, setVehicleTypes] = useState([{id:'',type:''}]);
    const [vehicleNumbers, setVehicleNumbers] = useState([{id:'',number:''}]);
    const [vehicleNumber, setVehicleNumber] = useState(['']);
    const [selectedVehicleTimingIds, setSelectedVehicleTimingIds] = useState([]);
    // const [vehicleSeatcapacity, setVehicleSeatcapacity] = useState([{id:'',capacity:''}]);
    const [vehicleSeatcapacity, setVehicleSeatcapacity] = useState(1);
    const [errors, setErrors] = useState({});
    const [ticketTypes, setTicketTypes] = useState({
        ticket_type_id:"",
        ticket_sub_type_id:"",
        ticket_sub_sub_type_id:"",
    });
    useEffect(() => {
        if (auth?.token && placeId) {
            dispatch(getZoneListByPlace(auth.token, placeId));
            dispatch(getVehicalCategoryList(auth.token,placeZoneId,placeId));
            dispatch(getTicketType(auth.token, placeId));
            dispatch(getAllCategoriesAndVehicals(auth.token, placeId));
            dispatch(getBookingTimingFormData(auth?.token,placeId));
        }
    }, [dispatch, auth?.token, placeId]);

    const handleTicketTypes = (e) => {
        const { name,value } = e.target;
        setTicketTypes((prev) => ({
            ...prev,
            [name] : value,
        }));
        if(name == 'ticket_type_id'){
            dispatch(getTicketSubType(auth.token, value));
        }
        if(name == 'ticket_sub_type_id'){
            dispatch(getTicketSubSubType(auth.token, value));
        }
    };

    const handleZoneChange = (e) => {
        const selectedZoneId = (e.target.value !='') ? e.target.value: 0;
        setPlaceZoneId(selectedZoneId);
        setIsEnabledZone(selectedZoneId ? true : false);
        if (auth?.token) {
            dispatch(getVehicalCategoryList(auth.token,selectedZoneId,placeId));
            dispatch(getSubZoneListByZone(auth.token, selectedZoneId));
        }
    };
    const handleVehicalCategory = (e) => {
        setVehicalCategory(e.target.value);
        if (auth?.token) {
            dispatch(getVehicalTypeList(auth.token, e.target.value));
        }
    };
    const handleVehicalType = (e) => {
        setVehicalTypeId(e.target.value)
        dispatch(getVehicalNumberList(auth.token, e.target.value));
    };
    const handleVehicalNumber = (e) => {
        setVehicleNumber(e.target.value);
    };
    const handleVehicleTimingSelection = (timingId) => {
        setSelectedVehicleTimingIds((prev) => (
            prev.includes(timingId)
                ? prev.filter((id) => id !== timingId)
                : [...prev, timingId]
        ));
    };
    const toggleVehicleCategory = (e) => {
        setIsEnabledZone(e.target.checked);
        if (!e.target.checked) {
            setVehicleCategories([]);
        }
    };
    const toggleSubVehicleCategory = (e) => {
        setIsEnabledCategory(e.target.checked);
        setVehicleTypes([{id:'',type:''}]);
        setVehicleNumbers([{id:'',number:''}]);
    };
    const toggleSubSubVehicleCategory = (e) => {
        setIsEnabledSubCategory(e.target.checked);
        setCapacity(true);
    };
    const toggleCapacity = (e) => {
        setCapacity(e.target.checked);
    };
    const addCategory = () => setVehicleCategories([...vehicleCategories, {id:'',category:''}]);
    const removeCategory = (index) => setVehicleCategories(vehicleCategories.filter((_, i) => i !== index));
    const handleCategoryChange = (e,index) => {
        const { name, value } = e.target;
        const updatedCategories = [...vehicleCategories];
        updatedCategories[index][name] = value;
        setVehicleCategories(updatedCategories);
    };
    const addVehicleType = () => setVehicleTypes([...vehicleTypes, {id:'',type:''}]);
    const removeVehicleType = (index) => setVehicleTypes(vehicleTypes.filter((_, i) => i !== index));
    const handleVehicleTypeChange = (index, e) => {
        const { name, value } = e.target;
        const updatedTypes = [...vehicleTypes];
        updatedTypes[index][name] = value;
        setVehicleTypes(updatedTypes);
    };
    // const addSeatcapacity = () => setVehicleSeatcapacity([...vehicleSeatcapacity, {id:'',capacity:''}]);
    // const removeSeatCapacity = (index) => setVehicleSeatcapacity(vehicleSeatcapacity.filter((_, i) => i !== index));

    const addVehicleNumber = () => setVehicleNumbers([...vehicleNumbers, {id:'',number:''}]);
    const removeVehicleNumber = (index) => setVehicleNumbers(vehicleNumbers.filter((_, i) => i !== index));
    const handleVehicleNumberChange = (index, e) => {
        const { name, value } = e.target;
        const updatedNumbers = [...vehicleNumbers];
        updatedNumbers[index][name] = value;
        setVehicleNumbers(updatedNumbers);
    };
    const handleVehicleSeatCapacityChange = (index, e) => {
        const {name , value} = e.target;
        const updatedNumbers = [...vehicleSeatcapacity];
        updatedNumbers[index][name] = value;
        // setVehicleSeatcapacity(updatedNumbers);
    };
    const handleSubmitCategory = () => {

        if (vehicleCategories.length === 0) {
            alert("Please add at least one vehicle category.");
            return;
        }
        if (!placeZoneId) {
            toast.error('Please select a zone.');
            return;
        }
        const form = new FormData();
        form.append("zone_id", placeZoneId);
        form.append("place_id", placeId);
        form.append("vehicleCategories", JSON.stringify(vehicleCategories));
        form.append("ticket_type_id", ticketTypes.ticket_type_id);
        form.append("ticket_sub_type_id", ticketTypes.ticket_sub_type_id);
        form.append("ticket_sub_sub_type_id", ticketTypes.ticket_sub_sub_type_id);
        axios.post(`/api/admin/v1/addUpdate-vehicle-category`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message || "Sub-zone added successfully.");
            setDefultState();
        }).catch((err) => {
            const errorMessage = err.response?.data?.message || "An error occurred";
            toast.error(errorMessage);
            if (err.response?.data?.errors) {
                setErrors(err.response.data.errors);
            } else {
                setErrors({ general: errorMessage });
            }
        });
    };

    const handleSubmitSubCategory = () => {
        if (VehicalCategory.length === 0) {
            alert("Please add at least one vehicle category.");
            return;
        }
        const form = new FormData();
        form.append("Vehical_Category", VehicalCategory);
        form.append("vehicle_types", JSON.stringify(vehicleTypes));
        axios.post(`/api/admin/v1/addUpdate-vehicle-type-name`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message || "Sub-zone added successfully.");
            setDefultState();
        }).catch((err) => {
            const errorMessage = err.response?.data?.message || "An error occurred";
            toast.error(errorMessage);
            if (err.response?.data?.errors) {
                setErrors(err.response.data.errors);
            } else {
                setErrors({ general: errorMessage });
            }
        });
    };
    const handleSubmitSubSubCategory = () => {
        if (vehicleCategories.length === 0) {
            alert("Please add at least one vehicle category.");
            return;
        }
        if (!VehicalTypeId) {
            toast.error('Please select a Vehicle Type/Name.');
            return;
        }
        if (vehicleNumbers.some(v => !v.number || v.number.trim() === '')) {
            toast.error('Vehicle Number is required');
            return;
        }
        const form = new FormData();
        form.append("VehicalTypeId", VehicalTypeId);
        form.append("vehicle_numbers", JSON.stringify(vehicleNumbers));
        axios.post(`/api/admin/v1/addUpdate-vehicle-number`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message || "Sub-zone added successfully.");
            setDefultState();
        }).catch((err) => {
            const errorMessage = err.response?.data?.message || "An error occurred";
        });
    };
    const handleSubmitSeatCapacity = () => {
        if (vehicleCategories.length === 0) {
            alert("Please add at least one vehicle category.");
            return;
        }
        if (vehicleSeatcapacity == '') {
            toast.error('Vehicle Capacity is required');
            return;
        }
        if (vehicleSeatcapacity == 0) {
            toast.error('Vehicle Capacity must be greater than 0');
            return;
        }
        if (!vehicleNumber || vehicleNumber == 0) {
            toast.error('Vehicle number is required');
            return;
        }
        const form = new FormData();
        form.append("vehicle_number", vehicleNumber);
        form.append("vehicle_seat_capacity", vehicleSeatcapacity);
        if (selectedVehicleTimingIds.length > 0) {
            form.append("vehicle_booking_period_ids", JSON.stringify(selectedVehicleTimingIds));
        }
        axios.post(`/api/admin/v1/addUpdate-vehicle-seat-capacity`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message || "Sub-zone added successfully.");
            setDefultState();
        }).catch((err) => {
            const errorMessage = err.response?.data?.message || "An error occurred";
            toast.error(errorMessage);
            if (err.response?.data?.errors) { setErrors(err.response.data.errors); }
            else { setErrors({ general: errorMessage }); }
        });
    };
    const handleZoneDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Zone")) {
        axios
            .delete(`/api/admin/v1/zone-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllZonesByPlace(auth.token, placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    const editVehicle = (item) => {
        const vehicle_type = item?.vehicle_type;
        const category = item?.vehicle_type?.vehicle_category;
        const zone = item?.vehicle_type?.vehicle_category?.zone;
        const seat = item?.seat_capacity;
        const slots = item?.vehicleSlots;
        setTicketTypes({
            ticket_type_id:category?.ticket_type_id,
            ticket_sub_type_id:category?.ticket_sub_type_id,
            ticket_sub_sub_type_id:category?.ticket_sub_sub_type_id,
        });
        dispatch(getTicketSubType(auth.token, category?.ticket_type_id));
        dispatch(getTicketSubSubType(auth.token, category?.ticket_sub_type_id));
        setPlaceZoneId(category?.place_zone_id ?? 0);
        setIsEnabledZone(true);
        setVehicleCategories([{
            id:category?.id,
            category:category?.vehicle_category ?? '',
            place_zone_id:placeZoneId,
            ticket_type_id:ticketTypes.ticket_type_id,
            ticket_sub_type_id:ticketTypes.ticket_sub_type_id,
            ticket_sub_sub_type_id:ticketTypes.ticket_sub_sub_type_id,
        }]);
        setIsEnabledCategory(true);
        setVehicalCategory(vehicle_type?.vehicle_category_id ?? 0);
        setIsEnabledSubCategory(true);
        setVehicleTypes([{id:vehicle_type?.id,type:vehicle_type?.vehicle_type}]);
        setCapacity(true);
        setVehicalTypeId(item?.vehicle_type_id ?? 0);
        dispatch(getVehicalTypeList(auth.token, vehicle_type?.vehicle_category_id));
        dispatch(getVehicalNumberList(auth.token, item?.vehicle_type_id));
        setVehicleNumbers([{id:item?.id,number:item?.vehicle_number ?? ''}]);
        setVehicleNumber(seat?.vehicle_number_id ?? 0)
        setVehicleSeatcapacity(item?.max_booking_seats ?? 1);
        setSelectedVehicleTimingIds(slots?.length > 0 ? slots?.map((slot) => slot?.timing_id) :[]);
    }

    const setDefultState = () => {
        setIsEdit(false);
        setTicketTypes({
            ticket_type_id:'',
            ticket_sub_type_id:'',
            ticket_sub_sub_type_id:'',
        });
        setPlaceZoneId(0);
        setVehicalTypeId(0);
        setVehicleNumber(0);
        setSelectedVehicleTimingIds([]);
        setVehicalCategory(0);
        setCapacity(false);
        setIsEnabledZone(false);
        setIsEnabledCategory(false);
        setIsEnabledSubCategory(false);
        setVehicleCategories([{id:'',category:''}]);
        setVehicleTypes([{id:'',type:''}]);
        setVehicleNumbers([{id:'',number:''}]);
        // setVehicleSeatcapacity([{id:'',capacity:''}]);
        setVehicleSeatcapacity(1);
        dispatch(getVehicalCategoryList(auth.token, placeZoneId));
        dispatch(getAllCategoriesAndVehicals(auth.token, placeId));
    }

    const handleVehicleCatDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete ?")) {
        axios.delete(`/api/admin/v1/vehicle-category-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllCategoriesAndVehicals(auth.token, placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    const handleVehicleTypeDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete ?")) {
        axios.delete(`/api/admin/v1/vehicle-type-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllCategoriesAndVehicals(auth.token, placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    const handleVehicleNumDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete ?")) {
        axios.delete(`/api/admin/v1/vehicle-number-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllCategoriesAndVehicals(auth.token, placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };
    const vehicleTimingOptions = bookingTimings.filter((item) => item?.type === "vehicle_booking_period");
    return (
        <div className="container">
            <Row>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_type_id"
                            value={ticketTypes.ticket_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Type</option>
                                {TicketTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.ticket_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_type_id}</span>
                    </div>
                </Col>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_sub_type_id"
                            value={ticketTypes.ticket_sub_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Sub Type</option>
                                {TicketSubTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.sub_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_sub_type_id}</span>
                    </div> 
                </Col>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_sub_sub_type_id"
                            value={ticketTypes.ticket_sub_sub_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Type</option>
                                {TicketSubSubTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.sub_sub_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_sub_sub_type_id}</span>
                    </div> 
                </Col>
            </Row>
            <Card className="mb-4 shadow-sm">
                <CardBody>
                    <Row className="">
                        <Col md={6} className="p-3 border rounded shadow-sm">
                            <FormGroup>
                                <Label className="fw-bold">Zone<span className="text-danger">*</span></Label>
                                <Input type="select" name="zone_id" value={placeZoneId} onChange={handleZoneChange}>
                                    <option value="">Select Zone</option>
                                    {PlaceZonelists.map((item) => (<option key={item.id} value={item.id}>{item.zone_name}</option>))}
                                </Input>
                            </FormGroup>
                            <div className="d-flex align-items-center mb-2">
                                <Input type="checkbox" checked={isEnabledZone} onChange={toggleVehicleCategory} className="me-2" />
                                <Label className="fw-bold m-0 me-3">
                                    Vehicle Category <span className="text-danger">*</span>
                                </Label>
                                {isEdit.category != true && (
                                    <Button className="bg-primary text-white" size="sm" onClick={addCategory} disabled={!isEnabledZone}>
                                        Add Category
                                    </Button>
                                )}
                            </div>
                            {isEnabledZone && vehicleCategories.map((cat, catIndex) => (
                                <Row key={`category-${catIndex}`} className=" mb-2">
                                    <Col md={10}>
                                        <Input type="text" name='category' value={cat.category} onChange={(e) => handleCategoryChange(e,catIndex)} placeholder="Enter Vehicle Category" disabled={!isEnabledZone} className="border-primary" />
                                    </Col>
                                    <Col md={2} className="text-end">
                                    {isEdit.category != true && (
                                        <Button className="bg-danger text-white px-2" size="sm" onClick={() => removeCategory(catIndex)} disabled={!isEnabledZone}>
                                            &times;
                                        </Button>
                                    )}
                                    </Col>
                                </Row>
                            ))}
                            <div className="mt-3 text-end">
                                {isEdit.category ? (
                                <Button className="bg-success text-white" onClick={handleSubmitCategory} disabled={!isEnabledZone || vehicleCategories.length === 0}>
                                    Update
                                </Button>
                                ): (
                                <Button className="bg-success text-white" onClick={handleSubmitCategory} disabled={!isEnabledZone || vehicleCategories.length === 0}>
                                    Submit
                                </Button>
                                )}
                            </div>
                        </Col>
                        <Col md={6} className="p-3 border rounded shadow-sm">
                            <FormGroup>
                                <Label className="fw-bold">Vehical Category <span className="text-danger">*</span></Label>
                                <Input type="select" name="zone_id" value={VehicalCategory} onChange={handleVehicalCategory}>
                                    <option value="">Select Category</option>
                                    {VehicalCategoryList.map((item) => (
                                        <option key={item.id} value={item.id}>{item.vehicle_category}  ({item?.zone?.zone_name ?? 'N/A'})</option>
                                    ))}
                                </Input>
                            </FormGroup>
                            <div className="d-flex align-items-center mb-2">
                                <Input type="checkbox" checked={isEnabledCategory} onChange={toggleSubVehicleCategory} className="me-2" />
                                <Label className="fw-bold m-0 me-3">
                                    Vehicle Type/Name <span className="text-danger">*</span>
                                </Label>{isEdit.type != true && (
                                <Button className="bg-primary text-white" size="sm" onClick={addVehicleType} disabled={!isEnabledCategory}>
                                    Add Vehicle Type
                                </Button>
                                )}

                            </div>
                            <Row key={`category`} className="align-items-start mb-3">
                                <Col md={12} className=" rounded p-2 mb-2">
                                    <h6 className="fw-bold">{ }</h6>
                                    {vehicleTypes.length > 0 ? (
                                        vehicleTypes.map((type, typeIndex) => (
                                            <Row key={`type-${typeIndex}`} className=" mt-2">
                                                <Col md={10}>
                                                    <Input type="text" name='type' value={type?.type} onChange={(e) => handleVehicleTypeChange(typeIndex, e)} placeholder="Enter Vehicle Type" disabled={!isEnabledZone} className="border-primary" />
                                                </Col>
                                                <Col md={2} className="text-end">
                                                {isEdit.type != true && (
                                                    <Button className="bg-danger text-white px-2" size="sm" onClick={() => removeVehicleType(typeIndex)} disabled={!isEnabledZone}>&times;
                                                    </Button>
                                                )}
                                                </Col>
                                            </Row>
                                        ))
                                    ) : ""}
                                    <span> <b>Note:</b><span className="text-danger"> To Enable the Vehicle Type/Name please select Zone</span></span>
                                </Col>
                            </Row>
                            <div className="mt-3 text-end">
                                {isEdit.type ? (
                                    <Button className="bg-success text-white" onClick={handleSubmitSubCategory} disabled={!isEnabledCategory || vehicleTypes.length === 0}
                                    >Update</Button>
                                ): (
                                <Button className="bg-success text-white" onClick={handleSubmitSubCategory} disabled={!isEnabledCategory || vehicleTypes.length === 0}
                                >Submit</Button>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <Row className="">
                        <Col md={6} className="p-3 border rounded shadow-sm">
                            <FormGroup>
                                <Label className="fw-bold">Vehicle Type/Name <span className="text-danger">*</span></Label>
                                <Input type="select" name="zone_id" value={VehicalTypeId} onChange={handleVehicalType}>
                                    <option value="">Select Vehicle Type/Name</option>
                                    {VehicalsTypelists.map((item) => (
                                        <option key={item.id} value={item.id}>{item.vehicle_type}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                            <div className="d-flex align-items-center mb-2">
                                <Input type="checkbox" checked={isEnabledSubCategory} onChange={toggleSubSubVehicleCategory} className="me-2" />
                                <Label className="fw-bold m-0 me-3">
                                    Vehicle Number <span className="text-danger">*</span>
                                </Label>
                                {/* <Button className="bg-primary text-white" size="sm" onClick={addVehicleNumber} disabled={!isEnabledSubCategory}>
                                    Add Vehicle Number
                                </Button> */}
                            </div>

                            <Row className="align-items-start mb-3">
                                <Col md={12} className=" rounded p-2 mb-2">
                                    <h6 className="fw-bold"> Add Vehicle Number </h6>
                                    {vehicleNumbers.length > 0 ? (
                                        vehicleNumbers.map((number, numIndex) => (
                                            <Row key={`number-${numIndex}`} className=" mt-2">
                                                <Col md={10}>
                                                    <Input type="text" name="number" value={number.number} onChange={(e) => handleVehicleNumberChange(numIndex, e)} placeholder="Enter Vehicle Number" className="border-primary" />
                                                </Col>
                                                <Col md={2} className="text-end">
                                                    {isEdit.number != true &&  (
                                                        <Button className="bg-danger text-white px-2" size="sm" onClick={() => removeVehicleNumber(numIndex)} >
                                                            &times;
                                                        </Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        ))
                                    ) : ""}
                                    {/* <span> <b>Note:</b><span className="text-danger"> Please select Zone & Vehical Category</span></span> */}
                                </Col>
                            </Row>

                            <div className="mt-3 text-end">
                                {isEdit.number ? ( 
                                <Button className="bg-success text-white" onClick={handleSubmitSubSubCategory} disabled={!isEnabledSubCategory || vehicleNumbers.length === 0}>
                                    Update
                                </Button>
                                ): (  
                                <Button className="bg-success text-white" onClick={handleSubmitSubSubCategory} disabled={!isEnabledSubCategory || vehicleNumbers.length === 0}>
                                    Submit
                                </Button>
                                )}
                            </div>
                        </Col>
                        <Col md={6} className="p-3 border rounded shadow-sm">
                            <FormGroup>
                                <Label className="fw-bold">Vehicle Number <span className="text-danger">*</span></Label>
                                <Input type="select" name="zone_id" value={vehicleNumber} onChange={handleVehicalNumber}>
                                    <option value="">Select Vehicle Number</option>
                                    {VehicalsNumberlists.map((item) => (
                                        <option key={item.id} value={item.id}>{item.vehicle_number}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                            <FormGroup className="mb-3">
                                <Label className="fw-bold mb-2">Vehicle Timing (Multiple Select)</Label>
                                {vehicleTimingOptions.length > 0 ? (
                                    vehicleTimingOptions.map((timing) => (
                                        <div key={timing.id} className="d-flex align-items-center mb-1">
                                            <Input
                                                type="checkbox"
                                                className="me-2"
                                                checked={selectedVehicleTimingIds.includes(timing.id)}
                                                onChange={() => handleVehicleTimingSelection(timing.id)}
                                            />
                                            <Label className="m-0">
                                                {`${timing.start_time ?? ''} - ${timing.end_time ?? ''}`}
                                            </Label>
                                        </div>
                                    ))
                                ) : (
                                    <small className="text-muted">No vehicle timings found.</small>
                                )}
                            </FormGroup>
                            <div className="d-flex align-items-center mb-2">
                                <Input type="checkbox" checked={isCapacity} onChange={toggleCapacity} className="me-2" />
                                <Label className="fw-bold m-0 me-3">
                                    Capacity <span className="text-danger">*</span>
                                </Label>
                                {/* {isEdit.number != true && (  
                                <Button className="bg-primary text-white" size="sm" onClick={addSeatcapacity} disabled={!isCapacity}>
                                    Add Seat Capacity
                                </Button>
                                )} */}
                            </div>
                            <Row className="align-items-start mb-3">
                                <Col md={12} className=" rounded p-2 mb-2">
                                    <h6 className="fw-bold"> Add Seat Capacity </h6>
                                    <Row key={`number-1`} className=" mt-2">
                                        <Col md={10}>
                                            <Input type="number" min="1" name="capacity" value={vehicleSeatcapacity} onChange={(e) => setVehicleSeatcapacity(e.target.value)} placeholder="Enter Seat Capacity" className="border-primary" />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <div className="mt-3 text-end">
                                {isEdit.number ? ( 
                                <Button className="bg-success text-white" onClick={handleSubmitSeatCapacity} disabled={!vehicleSeatcapacity.length === 0}>
                                    Update
                                </Button>
                                ): ( 
                                <Button className="bg-success text-white" onClick={handleSubmitSeatCapacity} disabled={!vehicleSeatcapacity.length === 0}>
                                    Submit
                                </Button>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <AdditionalFormFields addFormType={'vehicle'} placeId={placeId}/>
                    <Row>
                        <Col md={6} className="mt-3">
                            <Card className="mb-4 shadow-sm">
                                <CardHeader className="bg-secondary text-white">
                                    <h6 className="mb-0">All Vehicle Categories </h6>
                                </CardHeader>
                                <CardBody>
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Zone</th>
                                                <th>Category</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {vehicleCategoriesList.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item?.zone?.zone_name}</td>
                                                <td>{item?.vehicle_category}</td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <AiOutlineEdit
                                                        size={22}
                                                        className="text-warning me-3"
                                                        onClick={() => {
                                                            setIsEdit((prev) => ({...prev,category:true}));
                                                            setTicketTypes({
                                                                ticket_type_id:item?.ticket_type_id,
                                                                ticket_sub_type_id:item?.ticket_sub_type_id,
                                                                ticket_sub_sub_type_id:item?.ticket_sub_sub_type_id,
                                                            });
                                                            dispatch(getTicketSubType(auth.token, item?.ticket_type_id));
                                                            dispatch(getTicketSubSubType(auth.token, item?.ticket_sub_type_id));
                                                            setPlaceZoneId(item?.place_zone_id ?? 0);
                                                            setIsEnabledZone(true);
                                                            setVehicleCategories([{
                                                                id:item?.id,
                                                                category:item?.vehicle_category ?? '',
                                                                place_zone_id:placeZoneId,
                                                                ticket_type_id:ticketTypes.ticket_type_id,
                                                                ticket_sub_type_id:ticketTypes.ticket_sub_type_id,
                                                                ticket_sub_sub_type_id:ticketTypes.ticket_sub_sub_type_id,
                                                            }]);
                                                        }}
                                                        />
                                                        <AiOutlineDelete
                                                            size={22}
                                                            className="text-danger"
                                                            onClick={() => handleVehicleCatDel(item.id)}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Card className="mb-4 shadow-sm">
                                <CardHeader className="bg-secondary text-white">
                                    <h6 className="mb-0">All Vehicle Type/Name </h6>
                                </CardHeader>
                                <CardBody>
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Category</th>
                                                <th>Type/Name</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {vehicleTypeList.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item?.vehicle_category?.vehicle_category}</td>
                                                <td>{item?.vehicle_type}</td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <AiOutlineEdit
                                                        size={22}
                                                        className="text-warning me-3"
                                                        onClick={() => {
                                                            setIsEdit((prev) => ({...prev,type:true}));
                                                            setIsEnabledZone(true);
                                                            setIsEnabledCategory(true);
                                                            setVehicalCategory(item?.vehicle_category_id ?? 0);
                                                            setIsEnabledSubCategory(true);
                                                            setVehicleTypes([{id:item?.id,type:item?.vehicle_type}]);
                                                        }}
                                                        />
                                                        <AiOutlineDelete
                                                            size={22}
                                                            className="text-danger"
                                                            onClick={() => handleVehicleTypeDel(item.id)}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={12} className="mt-3">
                            <Card className="mb-4 shadow-sm">
                                <CardHeader className="bg-secondary text-white">
                                    <h6 className="mb-0">All Vehicle </h6>
                                </CardHeader>
                                <CardBody>
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Zone</th>
                                                <th>Category</th>
                                                <th>Type/Name</th>
                                                <th>Registration Number</th>
                                                <th>Seat Capacity </th>
                                                <th>Vehicle Timing </th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {vehicleNumList.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item?.vehicle_types?.vehicle_category?.zone?.zone_name ?? 'N/A'}</td>
                                                <td>{item?.vehicle_types?.vehicle_category?.vehicle_category ?? 'N/A'}</td>
                                                <td>{item?.vehicle_types?.vehicle_type ?? 'N/A'}</td>
                                                <td>{item?.vehicle_number ?? 'N/A'}</td>
                                                <td>
                                                    {item?.vehicleSlots?.length > 0 ? (
                                                        item.vehicleSlots.map((slot, slotIndex) => {
                                                            const startTime = slot?.bookingTiming?.start_time;
                                                            const endTime = slot?.bookingTiming?.end_time;
                                                            return (
                                                                <React.Fragment key={slot?.id ?? slotIndex}>
                                                                    <span className="badge badge-success me-1">
                                                                        {`${startTime ?? 'N/A'} - ${endTime ?? 'N/A'}`}
                                                                    </span>
                                                                    {/* {slotIndex < item.vehicleSlots.length - 1 ? ", " : ""} */}
                                                                </React.Fragment>
                                                            );
                                                        })
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </td>
                                                <td>{item?.max_booking_seats}</td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <AiOutlineEdit
                                                        size={22}
                                                        className="text-warning me-3"
                                                        onClick={() => {
                                                            editVehicle(item);
                                                            setIsEdit((prev) => ({...prev,number:true}));
                                                        }}
                                                        />
                                                        <AiOutlineDelete
                                                            size={22}
                                                            className="text-danger"
                                                            onClick={() => handleVehicleNumDel(item.id)}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
};

export default PlaceZone;
